export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/sumoday-flag.3880ac3b.svg","height":40,"width":145};